import { Article, OrderItem } from './components/types';

export enum ItemType {
  Singular = 'singular',
  Countable = 'countable',
  Loose = 'loose',
}

export function getInventoryArticleType(
  article: OrderItem | Article,
): ItemType {
  if (!article.amount && !article.unit) {
    return ItemType.Singular;
  } else if (article.amount && article.unit && !article.loose) {
    return ItemType.Countable;
  } else {
    return ItemType.Loose;
  }
}
